// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1e28B","col":"Table_col__4U3oe","fulfillmentStatus":"Table_fulfillmentStatus__zc9RL","emailCol":"Table_emailCol__TC1cv"};